import * as userRequest from "@/utils/userRequest";

export default async function getGiftCardsService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("/boost/card", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (res) {
            onSuccess && onSuccess(res.data);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getGiftCardsService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
